<template>
  <aside
    v-if="showCookieComply && !isModalOpen"
    class="cookie-comply"
  >
    <div class="cookie-comply__header">
      <slot name="header">
        <h3 class="cookie-comply__header-title">
          {{ headerTitle }}
        </h3>
        <p class="cookie-comply__header-description">
          {{ headerDescription }}
        </p>
      </slot>
    </div>
  
    <div class="cookie-comply__actions">
      <cookie-comply-button @handleClick="openPreferences">
        {{ $t('cookieFooter.preferences') }}
      </cookie-comply-button>
      <cookie-comply-button
        style="background-color:#007c9f"
        class-name="cookie-comply__button-accept"
        @handleClick="handleAcceptAll"
      >
        {{ $t('cookieFooter.acceptAll') }}
      </cookie-comply-button>
    </div>
  
    <Teleport :to="target">
      <cookie-comply-modal
        v-if="isModalOpen"
        :preferences="preferences"
        @cookie-comply-save="onSave"
        @cookie-comply-close="isModalOpen = false"
      >
        <template #modal-header>
          <slot name="modal-header" />
        </template>
  
        <template #modal-body="{ preference, index }">
          <slot
            name="modal-body"
            :preference="preference"
            :index="index"
          />
        </template>
  
        <template #modal-footer>
          <slot name="modal-footer" />
        </template>
      </cookie-comply-modal>
    </Teleport>
  </aside>
</template>
  
<script>
import CookieComplyModal from './CookieComplyModal.vue';
import CookieComplyButton from './CookieComplyButton.vue';
  
export default {
  name: 'CookieComply',
  components: { CookieComplyModal, CookieComplyButton },
  props: {
    preferencesLabel: { type: String, default: 'Preferences' },
    acceptAllLabel: { type: String, default: 'Accept All' },
    preferences: { type: Array, default: () => [] },
    target: { type: String, default: 'body' }
  },
  emits: [ 'on-accept-all-cookies', 'on-save-cookie-preferences' ],
  data() {
    return {
      showCookieComply: true,
      headerTitle:  this.$t('cookieFooter.headerTitle'),
      headerDescription: this.$t('cookieFooter.headerDescription'),
      isModalOpen: false
    };
  },
  mounted() {
  },
  methods: {
    handleAcceptAll() {
      this.showCookieComply = false;
      this.$emit('acceptAllCookies');
    },
    openPreferences() {
      this.$emit('openCookieModal');
      this.isModalOpen = true;
    },
    onSave() {
      this.isModalOpen = false;
      this.showCookieComply = false;
      this.$emit('closeCookieModal');
    }
  }
};
</script>
  
<style>
@import './variable.css';

.cookie-comply {
  display: grid;
  grid-gap: var(--spacing-lg);
  grid-template-columns: 1fr minmax(35%, 40%);
  position: fixed;
  bottom: var(--spacing-sm);
  left: var(--spacing-sm);
  right: var(--spacing-sm);
  background-color: var(--color-white);
  box-shadow: var(--box-shadow);
  padding: var(--spacing-md);
  border-radius: var(--border-radius);
  z-index: 1000;
}

.cookie-comply__header {
  justify-self: flex-start;
  text-align: initial;
}

.cookie-comply__header-title,
.cookie-comply__header-description {
  margin: 0;
}

.cookie-comply__header-title {
  margin-bottom: var(--spacing-sm);
  font-size: 1.25rem;
}

.cookie-comply__header-description {
  line-height: 1.5;
  font-size: 0.9rem;
}

.cookie-comply__actions {
  display: grid;
  grid-gap: var(--spacing-lg);
  grid-template-columns: repeat(2, 1fr);
  align-self: center;
}

.cookie-comply__button-accept {
  background-color: var(--color-green);
  color: white;
  border: none;
}

@media (max-width: 1024px) {
  .cookie-comply {
    grid-template-columns: 1fr;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 0;
    padding: var(--spacing-md);
  }

  .cookie-comply__header {
    margin-bottom: var(--spacing-md);
  }

  .cookie-comply__header-title {
    font-size: 1.1rem;
  }

  .cookie-comply__header-description {
    font-size: 0.85rem;
  }

  .cookie-comply__actions {
    grid-template-columns: 1fr;
    gap: var(--spacing-sm);
  }

  .cookie-comply__button {
    width: 100%;
    padding: var(--spacing-md);
  }
}

@media (max-width: 480px) {
  .cookie-comply {
    padding: var(--spacing-sm);
  }

  .cookie-comply__header-title {
    font-size: 1rem;
  }

  .cookie-comply__header-description {
    font-size: 0.8rem;
  }

  .cookie-comply__button {
    padding: var(--spacing-sm);
    font-size: 0.9rem;
  }
}
</style>
  
